import React from 'react';
import TextField from '@mui/material/TextField';
import './CustomInput.scss';

const CustomInput = ({ label, type="text", value, onChange, placeholder,isDisabled, error ,maxLength, errortext,...rest}) => {
  // console.log("props recieved---",label,error,errortext);
  

  return (
    // <div className="input-wrapper">
    //   {label && <label className="input-label">{label}</label>}
    //   <input
    //     type={type}
    //     value={value}
    //     onChange={onChange}
    //     className={`input-field ${error ? 'input-error' : ''}`}
    //     placeholder={placeholder}
    //   />
    //   {error && <span className="input-error-message">{error}</span>}
    // </div>
    <TextField fullWidth
      label={label}
      value={value !== undefined ? String(value).slice(0, maxLength || undefined) : value}
      disabled={isDisabled}
      type={type} // Set input type dynamically
      onChange={(e) => {
        // Ensure value does not exceed maxLength
        if (maxLength) {
          e.target.value = e.target.value.slice(0, maxLength);
        }
        onChange(e);
      }}
      // placeholder={placeholder}
     {...rest}
     inputProps={{
      ...rest.inputProps,
      maxLength: maxLength,  // native HTML maxlength — browser enforces on typing
      autoComplete: 'off',  // Disable autocomplete here
      style: type !== "email" && type !== "password" ? { textTransform: "capitalize" } : {},
      inputMode: type === "number" ? "numeric" : undefined, // Use numeric keyboard for number type
      onKeyDown: (e) => {
        if (maxLength) {
          // Allow control keys: backspace, delete, arrows, tab, etc.
          const allowedKeys = ['Backspace','Delete','Tab','Escape','Enter','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'];
          const isCtrlCmd = e.ctrlKey || e.metaKey;
          if (!allowedKeys.includes(e.key) && !isCtrlCmd) {
            const input = e.target;
            // Block new character if already at max and nothing is selected
            if (input.value.length >= maxLength && input.selectionStart === input.selectionEnd) {
              e.preventDefault();
              return;
            }
          }
        }
        // Forward any onKeyDown passed via rest.inputProps
        if (rest.inputProps && rest.inputProps.onKeyDown) {
          rest.inputProps.onKeyDown(e);
        }
      },
      onPaste: (e) => {
        if (maxLength) {
          e.preventDefault();
          const input = e.target;
          const pasted = (e.clipboardData || window.clipboardData).getData('text');
          const start = input.selectionStart;
          const end = input.selectionEnd;
          const current = String(input.value);
          const newVal = (current.slice(0, start) + pasted + current.slice(end)).slice(0, maxLength);
          // Use native value setter to trigger React's onChange
          const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
          nativeSetter.call(input, newVal);
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (rest.inputProps && rest.inputProps.onPaste) {
          rest.inputProps.onPaste(e);
        }
      },
    }}
      // error={error}
      // helperText={errortext} 
      sx={{
        fontWeight: "500",
        color: "#171747",
        "& .MuiInputBase-root": {
          typography: {
            fontFamily: 'Rubik, serif',
            textTransform: (type !== 'email' && type !== 'password') ? 'capitalize' : 'none',
          }
        },
        '& .MuiAutocomplete-input': {
          backgroundColor: '#ffffff',
        },
        '& .MuiAutocomplete-option': {
          backgroundColor: '#ffffff !important',
        },
        '& .MuiOutlinedInput-root': {
          '&.Mui-focused': {  // Adjust focus style here
            borderColor: '#D3DFED', // Change the border color as needed
            borderWidth: '1px',     // Change the border width as needed
          },
        },        
      }}
    />
  );
};

export default CustomInput;